import { inject, observer } from 'mobx-react';
import React from 'react';
import MainSectionLayout from '../layout/MainSectionLayout';
import { Instance } from 'mobx-state-tree';
import { TLCode } from '../../common/enums';
import glamorous from 'glamorous';
import { PharmacyStatusStore, PharmacyStore } from '../../store';
import styled from '@emotion/styled';
import DutyAssignmentForm from './DutyAssignmentForm';
import { DutyAssignmentStore } from '../../store/DutyAssignmentStore';
import PharmacyDutiesList from './PharmacyDutiesList';
import TitledCard from '../common/TitledCard';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import { DutyAssignmentSearchCriteria } from './../../store/DutyAssignmentStore';
import { DutyStore } from './../../store/DutyStore';
import { DutyAssignment } from './../../store/models/DutyAssignment';

const Container2 = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
});

const Container = styled.div({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
});
const DivLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const DivColumn = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 20px;
`;

const ButtonsContainer = styled.div`
  display: flex;
  align-content: center;
  justify-content: flex-end;
  button {
    margin-left: 5px;
  },
  `;

interface DutyAssignmentPageProps extends WithTranslateProps {
  DutyAssignmentStore?: Instance<typeof DutyAssignmentStore>;
  DutyStore?: Instance<typeof DutyStore>;
  PharmacyStore?: Instance<typeof PharmacyStore>;
  PharmacyStatusStore?: Instance<typeof PharmacyStatusStore>;
}

interface DutyAssignmentPageState {
  isLoading: boolean;
  viewOnlyNeighbor: boolean;
  generatedDuties: Array<Instance<any>>;
  generatedId: number;
  dutieSamePeriod: Array<Instance<typeof DutyAssignment>>;
  searchCriteria: any;
}

@inject('DutyAssignmentStore')
@inject('DutyStore')
@inject('PharmacyStore')
@inject('PharmacyStatusStore')
@observer
class DutyAssignmentPage extends React.Component<DutyAssignmentPageProps, DutyAssignmentPageState> {
  state = {
    isLoading: false,
    viewOnlyNeighbor: true,
    generatedDuties: [],
    generatedId: 0,
    dutieSamePeriod: [],
    searchCriteria: {
      date: null,
      pharmacyIdForNeighbor: null,
    },
  } as DutyAssignmentPageState;

  _isMounted = false;

  async componentDidMount() {
    this._isMounted = true;
    const { PharmacyStore } = this.props;
    this._isMounted && this.setState({ isLoading: true });
    await PharmacyStore!.loadList();
    const { PharmacyStatusStore } = this.props;
    await PharmacyStatusStore!.checkListLoaded();
    this._isMounted && this.setState({ isLoading: false });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  onDelete = async (id: number) => {
    await this.props.DutyAssignmentStore!.unassignDuty(id);
    await this.getDutyAssignmentForSelection(this.state.searchCriteria);
  };

  onDeleteGenerated = async (id: number) => {
    console.log(this.state.generatedDuties);
    const generatedDuty = this.state.generatedDuties.find((d) => d.id == id);
    await generatedDuty.assignments.map((da) => this.props.DutyAssignmentStore!.unassignDuty(da.dutyAssignmentId));
    await this.getDutyAssignmentForSelection(this.state.searchCriteria);
    const filtered = this.state.generatedDuties.filter((d) => d.id != id);
    this._isMounted && this.setState({ generatedDuties: filtered });
  };

  save = async (data: any) => {
    console.log('save data ' + data);
    const res = await this.props.DutyAssignmentStore!.assignDuty(data);

    // @ts-ignore
    if (res) {
      const id = this.state.generatedId + 1;
      const padId = ('' + id).padStart(4, '0');
      data.id = `new-${padId}`;
      data.assignments = res;
      const generatedDuties = this.state.generatedDuties;
      generatedDuties.push(data);
      // @ts-ignore
      this._isMounted && this.setState({ generatedDuties, generatedId: id });
    }
  };

  getDutyAssignmentForSelection = async (dataSearch: DutyAssignmentSearchCriteria) => {
    const { DutyAssignmentStore, DutyStore } = this.props;
    const searchCriteria = {
      date: dataSearch.date,
      pharmacyIdForNeighbor: this.state.viewOnlyNeighbor ? dataSearch.pharmacyIdForNeighbor : undefined,
      notAssigned: false,
    };
    this._isMounted && this.setState({ searchCriteria: searchCriteria });
    await Promise.all([
      DutyAssignmentStore!.searchAssignment(searchCriteria),
      DutyStore!.searchForDutyAssignment(searchCriteria),
    ])
      .catch((e) => console.error(e))
      .then((responses) => {
        this._isMounted && this.setState({ dutieSamePeriod: responses[0] });
      });
  };

  buildGeneratedDuties() {
    const { PharmacyStore } = this.props;
    return this.state.generatedDuties.map((dut) => {
      const pharmacy = PharmacyStore!.getById(dut.pharmacyId);
      return {
        id: dut.id,
        pharmacyId: dut.pharmacyId,
        apbNumber: pharmacy ? pharmacy.apbNumber : '',
        pharmacyName: pharmacy ? pharmacy.name : '',
        city: pharmacy ? pharmacy.city : '',
        date: dut.date,
        type: dut.type,
      };
    });
  }

  render() {
    const { PharmacyStore, PharmacyStatusStore, translate } = this.props;
    const pharmacyList = PharmacyStore!.dataList;
    const pharmacyStatusList = PharmacyStatusStore!.dataList;
    const generatedDuties = this.buildGeneratedDuties();
    // const dutiesSamePeriod = this.buildDutiesSamePeriod();
    const searchCriteria = this.state.searchCriteria;

    return (
      <MainSectionLayout isLoading={this.state.isLoading}>
        <Container>
          <FullContainer style={{ marginRight: '15px' }}>
            <TitledCard title={TLCode.DUTYASSIGNMENT_Title}>
              <DutyAssignmentForm
                pharmacyList={pharmacyList}
                cleanGeneratedDuties={() => this.setState({ generatedDuties: [] })}
                save={this.save}
                searchCriteria={searchCriteria}
                getDutyAssignmentForSelection={this.getDutyAssignmentForSelection}
                pharmacyStatusList={pharmacyStatusList}
              />
            </TitledCard>
          </FullContainer>
          <ObservationGridContainer>
            <FullContainer style={{ marginLeft: '10px' }}>
              <PharmacyDutiesList dataList={generatedDuties} onDelete={this.onDeleteGenerated} />
            </FullContainer>
          </ObservationGridContainer>
        </Container>
      </MainSectionLayout>
    );
  }
}

export default withTranslate(DutyAssignmentPage);

const ObservationGridContainer = styled.div({
  // marginTop: '5px',
  display: 'flex',
  flexDirection: 'row',
  height: '100%',
  justifyContent: 'space-between',
});

const FullContainer = styled.div({
  flex: 1,
});
